/**
 * The seat's German or English rendering of an email draft, for the owner
 * only – it is never sent (`email_meta.translation_md`). Sits in the central
 * panel under the body, so a draft in a language the owner cannot read is
 * still read where it is reviewed.
 */
import type { EmailDraftMeta } from "../../api/admin";
import { translationLabel } from "../../lib/emailDrafts";
import { Markdown } from "../Markdown";

export function EmailTranslation({ meta }: { meta: EmailDraftMeta | null }) {
  if (!meta?.translation_md) return null;
  return (
    <section className="border-t border-rule mt-6 pt-5">
      <h2 className="font-heading font-semibold mb-1">
        {translationLabel(meta.translation_language)} translation
      </h2>
      <p className="text-xs text-ink-low mb-3">Written by the employee for your review – not sent.</p>
      <Markdown text={meta.translation_md} />
    </section>
  );
}
